import { Router } from '@angular/router';
import { ConsumidorFormatter, ConsumidorModel, ConsumidorService } from '../shared/';

import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-consumidor-msg-senha-alterada',
  templateUrl: './consumidor-msg-senha-alterada.component.html',
  styleUrls: []
})
export class ConsumidorMsgSenhaAlteradaComponent implements OnInit, OnDestroy {

  consumidor: ConsumidorModel;

  constructor(private readonly consumidorService: ConsumidorService,
    private readonly router: Router, ) { }

  ngOnInit() {
    const isSenhaAlterada = this.consumidorService.isSenhaAlterada;

    if (!isSenhaAlterada) {
      this.router.navigate(['consumidor/detalhar']);
    }

    this.consumidor = this.consumidorService.getConsumidorModel();
    this.consumidor.cpf = ConsumidorFormatter.pad(this.consumidor.cpfBase, 9) + ConsumidorFormatter.pad(this.consumidor.cpfDigito, 2);
  }

  onClick() {
    this.router.navigate(['consumidor/detalhar']);
  }

  ngOnDestroy() {
    this.consumidorService.isSenhaAlterada = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-msg-senha-alterada/consumidor-msg-senha-alterada.component.ts